/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bicycle'
export default icon
